export const PAGE_TITLE = process.env.REACT_APP_LITE
  ? "Firebolt Core"
  : "Firebolt";
